import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  imageData: yup.string().required(),
  invoiceId: yup.number().required(),
  uploadType: yup.string().required(),
});

export function useSignInvoiceMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.postSignInvoice(), {
      image_data: req.imageData,
      invoice_id: req.invoiceId,
      upload_type: req.uploadType,
    });
  }, options);
}
